import allScreeningsDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const allScreeningsReducer = allScreeningsDispatcher(initialState, {
  [allScreeningsDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [allScreeningsDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [allScreeningsDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default allScreeningsReducer;
